import React, { useState } from 'react';
import { Empty, Button, Icon, Popconfirm, message } from 'antd';
import { useMutation } from '@apollo/client';

import { MUTATION_DELETE_PMS_CONTACT } from '@pages/dashboard/pms-integrations/quires';

import ContactModal from '../contact-modal';

export default function Contact({ t, contactInfo = {}, refetch = () => {}, pmsId }) {
  const [visible, setVisible] = useState(false);
  const [actionType, setActionType] = useState('create');

  const infoObj = [
    { label: 'Contact name:', value: contactInfo?.contactName ?? '-' },
    { label: 'Email address:', value: contactInfo?.contactEmail ?? '-' },
    { label: 'Phone number:', value: contactInfo?.contactPhone ?? '-' },
    { label: 'Occupation:', value: contactInfo?.occupation ?? '-' },
  ];

  const onCloseModal = () => {
    setVisible(false);
  };

  const onOpenModal = () => {
    setVisible(true);
  };

  const handleDeleteContact = () => {
    deletePMSContact({
      variables: {
        input: {
          id: contactInfo.id,
        },
      },
    });
  };

  const [deletePMSContact] = useMutation(MUTATION_DELETE_PMS_CONTACT, {
    onCompleted: res => {
      if (res?.deletePMSContact?.contact?.id) {
        refetch();
      }
    },
    onError: e => {
      if (e) {
        message.error(e.toString());
      } else {
        message.error(t('Something wrong, please try again.'));
      }
    },
  });

  return (
    <div className="pms-contact">
      <div className="contact-title">{t('cms:cms.landlord.detail.contact.tab')}</div>
      {contactInfo?.id && (
        <div className="contact-wrapper">
          <div className="contact-header">
            <div className="contact-name">
              <Icon type="contacts" style={{ fontSize: 16, marginRight: 12 }} />
              {contactInfo.contactName}
            </div>
            <div className="contact-action">
              <span
                className="edit-action"
                onClick={() => {
                  onOpenModal();
                  setActionType('edit');
                }}
              >
                Edit
              </span>
              <Popconfirm
                overlayClassName="property-detail-wrapper__popconfirm"
                overlayStyle={{ maxWidth: 210 }}
                arrowPointAtCenter
                placement="topRight"
                title={t('cms:cms.landlord.contact.double_confirm.title')}
                onConfirm={handleDeleteContact}
                okText={t('cms:cms.properties.edit.btn.yes')}
                okType="danger"
                cancelText={t('cms:cms.properties.edit.btn.no')}
              >
                <span className="delete-action">{t('cms:cms.form.button.delete')}</span>
              </Popconfirm>
            </div>
          </div>
          <div className="contact-table">
            {infoObj.map((info, idx) => (
              <div key={idx} className="table-row">
                <div className="label">{info.label}</div>
                <div className="value">{info.value}</div>
              </div>
            ))}
          </div>
        </div>
      )}
      {!contactInfo?.id && (
        <Empty
          className="empty"
          description={<span>{t('cms:cms.landlord.pms_channel.detail.empty_desc')}</span>}
        >
          <Button
            type="ghost"
            icon="plus"
            className="add-btn"
            onClick={() => {
              onOpenModal();
              setActionType('create');
            }}
          >
            {t('cms:cms.landlord.pms_channel.contact.add_new_pms_contact')}
          </Button>
        </Empty>
      )}
      {visible && (
        <ContactModal
          t={t}
          visible={visible}
          onClose={onCloseModal}
          refetch={refetch}
          pmsId={pmsId}
          contactInfo={contactInfo}
          type={actionType}
        />
      )}
    </div>
  );
}
